import React, { createContext, useContext, useState } from "react";
import ReviewsModal from "@/components/reviews/ReviewsModal";

const ReviewsContext = createContext(null);

export const useReviews = () => {
  const context = useContext(ReviewsContext);
  if (!context) {
    throw new Error("useReviews must be used within a ReviewsProvider");
  }
  return context;
};

export const ReviewsProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState({
    webDomain: null,
    affiliateLink: null,
    companyName: null,
  });

  const openReviewsModal = ({ webDomain, affiliateLink, companyName }) => {
    setModalData({ webDomain, affiliateLink, companyName });
    setIsOpen(true);
  };

  const closeReviewsModal = () => {
    setIsOpen(false);
  };

  return (
    <ReviewsContext.Provider
      value={{ openReviewsModal, closeReviewsModal, isOpen }}
    >
      {children}
      <ReviewsModal
        open={isOpen}
        onOpenChange={setIsOpen}
        ebDomain={modalData.webDomain}
        affiliateLink={modalData.affiliateLink}
        companyName={modalData.companyName}
      />
    </ReviewsContext.Provider>
  );
};
